import { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import 'assets/css/MiniCalendar.css';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
// Chakra imports
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
// Custom components
import Card from 'components/card/Card';
import { dayKey } from 'utils';

export default function MiniCalendar(props: {
	selectRange: boolean;
	// Jours à mettre en évidence (clés dayKey), avec leur légende
	highlightedDays?: Set<string>;
	highlightLabel?: string;
	[x: string]: any;
}) {
	const { selectRange, highlightedDays, highlightLabel, ...rest } = props;
	const [ value, onChange ] = useState(new Date());
	return (
		<Card
			alignItems='center'
			flexDirection='column'
			w='100%'
			maxW='max-content'
			p='20px 15px'
			h='max-content'
			{...rest}>
			<Calendar
				onChange={onChange}
				value={value}
				selectRange={selectRange}
				view={'month'}
				locale='fr-FR'
				tileClassName={({ date, view }) =>
					view === 'month' && highlightedDays?.has(dayKey(date)) ? 'react-calendar__tile--highlighted' : null}
				prevLabel={<Icon as={MdChevronLeft} w='24px' h='24px' mt='4px' />}
				nextLabel={<Icon as={MdChevronRight} w='24px' h='24px' mt='4px' />}
			/>
			{highlightLabel && (
				<Flex align='center' mt='8px'>
					<Box h='6px' w='6px' bg='orange.400' borderRadius='50%' me='6px' />
					<Text fontSize='xs' color='secondaryGray.600' fontWeight='500'>
						{highlightLabel}
					</Text>
				</Flex>
			)}
		</Card>
	);
}
